import React from "react";
import { Grid } from "semantic-ui-react";
import PageHeader from "../SiteLayout/PageHeader";
import PageData from "../SiteLayout/Pages.json";
import TafsirRoutes from "./TafsirRoutes";
 
const TafsirMain = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <PageHeader Name={PageData.pages[1].name} Icon={PageData.pages[1].icon} Description={PageData.pages[1].description} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <TafsirRoutes />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
export default TafsirMain;